export enum ScheduleOptionsEnum {
    Send1time = 'send1time',
    SendeveryXTimes = 'sendeveryXTimes',
}
